import { useMultiSelectionContext } from 'src/contexts/MultiSelectionContext';

interface BulkActionsState {
  areBulkActionsEnabled: boolean;
}

export const useBulkActionsState = (): BulkActionsState => {
  const { totalItemsSelected, selectionMode } = useMultiSelectionContext();

  return {
    areBulkActionsEnabled: !!selectionMode || totalItemsSelected > 0,
  };
};
